import * as Yup from "yup";

export const YUPValidations = Yup.object().shape({
  centreSKUName: Yup.string()
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  centreSKUCode: Yup.string()
    .required("Field is required")
    .nullable()
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  // hvChargesId: Yup.string(/^[A-Za-z ]*$/)
  //   .nullable()
  //   .required("Field is required"),
  testTypeId: Yup.number()
    .min(1, "Field is required")
    .nullable()
    .required("Field is required"),
  mrp: Yup.number()
    .typeError("The field should have digits only")
    .moreThan(0, "MRP should be greater than zero")
    .test("decimal-places", "Only 2 decimal places are allowed", (value) => {
      if (value !== undefined && value !== null) {
        const decimalCount = (value.toString().split(".")[1] || "").length;
        return decimalCount <= 2;
      }
      return true;
    })
    .required("Field is required"),
  walkInPrice: Yup.number()
    .max(Yup.ref("mrp"))
    .typeError("The field should have digits only")
    .test("decimal-places", "Only 2 decimal places are allowed", (value) => {
      if (value !== undefined && value !== null) {
        const decimalCount = (value.toString().split(".")[1] || "").length;
        return decimalCount <= 2;
      }
      return true;
    })
    .moreThan(0, "WalkInPrice should be greater than zero")
    .required("Field is required"),
  isOutSourced: Yup.string(/^[A-Za-z ]*$/)
    .nullable()
    .required("Field is required"),
});

export const initialFilterState = {
  page: 1,
  rows: 10,
  centreSKUCode: null,
  centreSKUName: null,
  sortDirection: "DESC",
  RequestStatus: null,
};

export const initialHeaderTest = [
  "HA SKU Name",
  "Walk In Price",
  "MRP (Rs.)",
  "Outsourced",
];

export const TestExcelHeader = [
  { label: "Centre SKU Code", key: "centreSKUCode" },
  { label: "Centre SKU Name", key: "centreSKUName" },
  { label: "HA SKU Name", key: "haskuName" },
  { label: "Walk In Price", key: "walkInPrice" },
  { label: "MRP (Rs.)", key: "mrp" },
  { label: "HV Charges For", key: "hvChargesId" },
  { label: "Outsourced", key: "isOutSourced" },
  { label: "Test Type", key: "testTypeId" },
  { label: "Status", key: "requestStatus" },
];

export const TestExcelHeaderColmns = {
  "Centre SKU Code": "centreSKUCode",
  "Centre SKU Name": "centreSKUName",
  "HA SKU Name": "haskuName",
  "Walk In Price": "walkInPrice",
  "MRP (Rs.)": "mrp",
  "HV Charges For": "hvCharges",
  Outsourced: "isOutSourced",
  "Test Type": "testType",
  Status: "requestStatus",
};

export const CSVData = (getTestPackagesExcelDetail) =>
  getTestPackagesExcelDetail?.map((ele) => {
    return {
      centreSKUName: ele?.centreSKUName,
      centreSKUCode: ele?.centreSKUCode,
      haskuName: ele?.haskuName,
      walkInPrice: ele?.walkInPrice,
      mrp: ele?.mrp,
      hvChargesId: ele?.hvCharges,
      isOutSourced: ele?.isOutSourced ? "Yes" : "No",
      testTypeId: ele?.testType,
      requestStatus: ele?.requestStatus,
    };
  });
